import React, { forwardRef } from 'react';
import VectorLoader from './VectorLoader';

const BackgroundSection = forwardRef(
  (
    {
      imageUrl,
      height,
      children,
      className = '',
      loaderProgress = null,
      showLoader = false,
      bgStyle = {},
      bgClassName = '',
      imgClassName,
      ...props
    },
    ref
  ) => {
    const backgroundStyle = {
      backgroundImage: `url(${imageUrl})`,
      ...(height && { height }),
      ...bgStyle,
    };

    return (
      <div
        className={`relative background-section-container overflow-hidden ${bgClassName}`}
      >
        <div
          key={imageUrl}
          className={`full-height full-width background-section absolute ${
            imgClassName ?? ''
          }`}
          style={backgroundStyle}
          ref={ref}
          {...props}
        />
        {showLoader && (
          <div className='vector-loader-container'>
            <VectorLoader progress={loaderProgress} />
          </div>
        )}
        <div className={className} style={{ zIndex: 1 }}>
          {children}
        </div>
      </div>
    );
  }
);

export default BackgroundSection;
